/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/Old/PatientSelect/Content/Content/New/ReferralSource/Content/Referrals/Referral/Source/Search/SearchBar/Content/Content/Option/FirstLine/Content"
  
}) {
let constantData = ', '
let personBirthDateValueData = fromData.useDataFormat({ viewPath,
context: 'person',
path: 'birth_date',
format: fromFormat.age,
})
let constantData1 = ','
let aggregateData = fromAggregate.joinNoSpace(constantData, personBirthDateValueData, constantData1)
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let personBirthDateValueData1 = fromData.useDataFormat({ viewPath,
context: 'person',
path: 'birth_date',
format: fromFormat.dateShortIn,
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 textOverflow="none"
 overflowX="visible"
 color={dtColorsNeutral900}
 data="', '"
 aggregate="/Data/aggregate.js joinNoSpace"
 data="person.birth_date"
 format="/Data/format.js age"
 data="','"
 aggregate="/Data/aggregate.js joinNoSpace"
 text={aggregateData}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginLeft={dtSpaceXxs}
 textOverflow="none"
 overflowX="visible"
 color={dtColorsNeutral900}
 data="person.birth_date"
 format="/Data/format.js dateShortIn"
 text={personBirthDateValueData1}
/>
{children}
</React.Fragment>)
}